import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";

import { Tooltip } from "components";
import { UWCheckResultMode } from "types";

import AuroraOutcomeField from "./auroraOutcomeField";
import { CheckResult } from "./checkListRow";

import { ReactComponent as Cancel } from "static/images/cancel.svg";
import { ReactComponent as Checked } from "static/images/checked.svg";
import { ReactComponent as Alert } from "static/images/warning-alert.svg";
import styles from "./checkListRow.module.scss";

type CheckListStatusProps = {
	checkResult: CheckResult;
	isLoading?: boolean;
	handleAuroraOutcomeSubmit: (values: { [key: string]: any }) => any;
	showAuroraOutcome: boolean;
	isExtractDataFailed?: boolean;
	isDisabledOutcome?: boolean;
	tooltip?: string;
};

const CheckListStatus = ({
	checkResult,
	isLoading,
	handleAuroraOutcomeSubmit,
	showAuroraOutcome = false,
	isExtractDataFailed,
	isDisabledOutcome = false,
	tooltip,
}: CheckListStatusProps) => {
	const statusIcon = checkResult?.success ? (
		<div className={clsx(styles.iconWrapper, "text-success")}>
			<Checked />
		</div>
	) : (
		<div className={clsx(styles.iconWrapper, "text-danger")}>
			<Cancel />
		</div>
	);

	const warningText = () => {
		if (checkResult?.errorMessage && !isEmpty(checkResult?.errorMessage)) {
			return checkResult?.errorMessage;
		} else if (checkResult?.resultMode === UWCheckResultMode.Empty.name) {
			return "Integration returned empty response. You may re-generate a report or contact integration directly for additional info";
		} else {
			return "Error while getting data. You may re-generate a report or contact integration directly for additional info";
		}
	};

	const warningBlock = (
		<Tooltip
			html={<div style={{ width: "300px" }}>{warningText()}</div>}
			maxWidth={200}
		>
			<div className={clsx(styles.iconWrapper, "text-warning")}>
				<Alert />
				<span className="text-muted">Fail</span>
			</div>
		</Tooltip>
	);

	const statusBlock = isExtractDataFailed ? warningBlock : statusIcon;

	return (
		<div className={styles.checkListStatus}>
			{showAuroraOutcome ? (
				<AuroraOutcomeField
					value={checkResult?.auroraOutcome}
					onSubmit={handleAuroraOutcomeSubmit}
					isLoading={isLoading}
					isDisabled={isDisabledOutcome}
					tooltip={tooltip}
				/>
			) : (
				statusBlock
			)}
		</div>
	);
};

export default CheckListStatus;
